import { TECHNOLOGIES } from "@constants/global.constants";

import { MixPointIcon, SplitIcon } from "@components/SVGs";

export const TECHNOLOGY_GROUPS = {
  PRETREATMENT: "pretreatment",
  BULK_DEMINERALIZATION: "bulkDemineralization",
  TRACE_CONTAMINANTS: "traceContaminants",
  POLISHING: "polishing",
  SPLIT_OTHER_NODES: "splitOtherNodes",
  WATER_CHEMISTRY: "waterChemistry",
};

export const TREATMENT_IDS = {
  ...TECHNOLOGIES,
  FEED: "feed",
  PRODUCT: "product",
  SPLIT: "split",
  MIX: "mix-point",
  ADJUST_PH: "adjust-ph",
  WQA: "wqa",
};

export const TECHNOLOGY_SECTIONS = [
  {
    group: TECHNOLOGY_GROUPS.PRETREATMENT,
    titleKey: "systemDesign.groups.pretreatment",
    items: [
      { id: TREATMENT_IDS.UF, label: "UF", tooltipKey: "systemDesign.tooltips.uf" },
      { id: TREATMENT_IDS.IXSD, label: "IXSD", tooltipKey: "systemDesign.tooltips.ixsd" },
      { id: TREATMENT_IDS.IXOS, label: "IXOS", tooltipKey: "systemDesign.tooltips.ixos" },
    ],
  },
  {
    group: TECHNOLOGY_GROUPS.BULK_DEMINERALIZATION,
    titleKey: "systemDesign.groups.bulkDemineralization",
    items: [
      { id: TREATMENT_IDS.RO, label: "RO", tooltipKey: "systemDesign.tooltips.ro" },
      { id: TREATMENT_IDS.CCRO, label: "CCRO", tooltipKey: "systemDesign.tooltips.ccro" },
      { id: TREATMENT_IDS.IXD, label: "IXD", tooltipKey: "systemDesign.tooltips.ixd" },
    ],
  },
  {
    group: TECHNOLOGY_GROUPS.TRACE_CONTAMINANTS,
    titleKey: "systemDesign.groups.traceContaminants",
    items: [
      { id: TREATMENT_IDS.IXN, label: "IXN", tooltipKey: "systemDesign.tooltips.ixn" },
      { id: TREATMENT_IDS.IXB, label: "IXB", tooltipKey: "systemDesign.tooltips.ixb" },
    ],
  },
  {
    group: TECHNOLOGY_GROUPS.POLISHING,
    titleKey: "systemDesign.groups.polishing",
    items: [
      { id: TREATMENT_IDS.IXMB, label: "IXMB", tooltipKey: "systemDesign.tooltips.ixmb" },
      { id: TREATMENT_IDS.IXCP, label: "IXCP", tooltipKey: "systemDesign.tooltips.ixcp" },
    ],
  },
];

export const CHEMISTRY_SPLIT_GROUP = [
  {
    group: TECHNOLOGY_GROUPS.SPLIT_OTHER_NODES,
    titleKey: "systemDesign.groups.splitOtherNodes",
    items: [
      {
        id: TREATMENT_IDS.FEED,
        labelKey: "systemDesign.feed",
        tooltipKey: "systemDesign.tooltips.feed",
      },
      {
        id: TREATMENT_IDS.PRODUCT,
        labelKey: "systemDesign.product",
        tooltipKey: "systemDesign.tooltips.product",
      },
      {
        id: TREATMENT_IDS.SPLIT,
        label: "",
        icon: <SplitIcon />,
        tooltipKey: "systemDesign.tooltips.split",
      },
      {
        id: TREATMENT_IDS.MIX,
        label: "",
        icon: <MixPointIcon />,
        tooltipKey: "systemDesign.tooltips.mixPoint",
      },
    ],
  },
  {
    group: TECHNOLOGY_GROUPS.WATER_CHEMISTRY,
    titleKey: "systemDesign.groups.waterChemistry",
    items: [
      {
        id: TREATMENT_IDS.ADJUST_PH,
        labelKey: "systemDesign.finalPhAdj",
        tooltipKey: "systemDesign.tooltips.adjustPh",
      },
      {
        id: TREATMENT_IDS.WQA,
        labelKey: "systemDesign.wqaAdj",
        tooltipKey: "systemDesign.tooltips.wqa",
      },
    ],
  },
];

export const RESTRICTED_TECHNOLOGY_IDS = new Set([
  TECHNOLOGIES.CCRO,
  TECHNOLOGIES.IXOS,
  TECHNOLOGIES.IXB,
  TECHNOLOGIES.IXCP,
]);

export const LAYOUT_MODES = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
  GRID: "grid",
  AUTO: "auto",
};

export const LAYOUT_CLASS_MAP = {
  [LAYOUT_MODES.VERTICAL]: "wp-tech-icons--vertical",
  [LAYOUT_MODES.HORIZONTAL]: "wp-tech-icons--horizontal",
  [LAYOUT_MODES.GRID]: "wp-tech-icons--grid",
  [LAYOUT_MODES.AUTO]: "wp-tech-icons--auto",
};

export const SYSTEM_DESIGN_DND_MIME_TYPE = "application/wp-system-design";
